import axios from 'axios';

// :NOTE: stuff defined by me

// const example: BuildInfo = {
//  buildId: "aa161b0fd",
//  buildTime: "2025-12-26T03:55:14.063Z"
// };
//
// const parsed: BuildInfo = JSON.parse(jsonString) as BuildInfo;

export type VersionInfo = {
  buildId: string;
  buildTime: string; // ISO 8601 timestamp, e.g. "2025-12-26T03:55:14.063Z"
};

export async function fetchVersionInfo(): Promise<VersionInfo> {
  try {
    const response = await axios.get<VersionInfo>('/version.json', {
      headers: {accept: 'application/json'},
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Include server response data if present for easier debugging
      const statusPart = error.response?.status
        ? ` (status ${error.response.status})`
        : '';
      throw new Error(
        `Failed to fetch version.json${statusPart}: ${error.message}`,
        {cause: error},
      );
    }

    throw error;
  }
}
